import baseAPI from "@/http";

const router = "api/relatorioadministrativo/relatorioadministrativo";

export const administrativeReportAPI = {
  create: (administrativeReport) => baseAPI.post(router, administrativeReport),
  update: (administrativeReport) => baseAPI.put(router, administrativeReport),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getByCity: (id) => baseAPI.get(`${router}` + "/get-by-municipio" + `/${id}`),
  getByFilter: (filter) => baseAPI.post(`${router}/get-by-filtro`, filter),
  getByUser: (id, contratoid) =>
    baseAPI.get(`${router}` + "/get-by-usuario" + `/${id}/${contratoid}`),
  analyse: (report) =>
    baseAPI.put(`${router}` + "/analisar-relatorio-administrativo", report),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  downloadAnexo: (relatorioAnexoId) =>
    baseAPI.post(
      "api/arquivo/anexo/download/relatorio-administrativo/" + relatorioAnexoId,
      null,
      { responseType: "blob" }
    ),
};
